class DateHelper{
    addYears(date,years){
        return new Date(date.getFullYear() + parseInt(years,10),date.getMonth(),date.getDate());
    }
    addDays(date,days){
        if(date){
            return new Date(date.getTime() + 24*60*60*1000*days);
        }else{
            return null;
        }
    }
    addHours(date,hours){
        return new Date(date.getTime() + 60*60*1000*hours);
    }
    addFiscalYear(date,years){
        return this.addDays(this.addYears(date,years),-1);
    }
    //mm/dd/yy
    toShortDate(dateStr) {
        if(!dateStr){
            return '';
        }
        var date = this.toDate(dateStr);
        return   (date.getMonth() + 1) + '/' + date.getDate()+ '/' + (date.getFullYear() - 2000);
    }
    //mm/dd/yyyy
    toShortDateForCrm(dateStr) {
        if (!dateStr) {
            return '';
        }
        var date = this.toDate(dateStr);
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + (date.getFullYear());
    }
    toShortDateIgnoreTimezone(dateStr) {
        if (!dateStr) {
            return '';
        }
        return this.toShortDate(this.addHours(this.toDate(dateStr), 9));
    }

    //hh:mm
    toShortTime(dateStr){
        if(!dateStr){
            return '';
        }
        var dt = this.toDate(dateStr);
        return this.pad(dt.getHours())+':'+this.pad(dt.getMinutes());
    }
    //hh:mm PM AM
    toShortTimeForCrm(dateStr) {
        if (!dateStr) {
            return '';
        }
        var dt = this.toDate(dateStr);
        return this.pad((dt.getHours() + 24) % 12 || 12)
            + ':' + this.pad(dt.getMinutes())
            + '' + (dt.getHours() >= 12 ? 'PM' : 'AM');
    }
    
    toShortDateRange(StartStr,EndStr){
        if(!StartStr){
            return '';
        }
        return this.toShortDate(StartStr) + '-' + this.toShortDate(EndStr);
    }
    toShortDateRangeIgnoreTimezone(startStr, endStr) {
        if (!startStr) {
            return '';
        } else if (!endStr) {
            return '';
        } else {
            return this.toShortDate(this.addHours(this.toDate(startStr), 9)) + '-' + this.toShortDate(this.addHours(this.toDate(endStr), 9));
        }
    }
    //9 => 09
    //11 => 11
    pad(number) {
        if ( number < 10 ) {
          return '0' + number;
        }
        return number;
    }
    //yyyy-mm-ddThh:mm
    toESTString(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = this.toDate(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) +
          'T' + this.pad( dt.getHours() ) +
          ':' + this.pad( dt.getMinutes() )
    };
    //yyyy-mm-dd
    toESTDateString(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = this.toDate(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) 
    };
    //yyyy-mm-ddThh:mm.sssZ
    toESTString2(dateStr) {
        if(!dateStr){
            return ''
        }
        let dt = this.toDate(dateStr);
        return dt.getFullYear() +
          '-' + this.pad( dt.getMonth() + 1 ) +
          '-' + this.pad( dt.getDate() ) +
          'T' + this.pad( dt.getHours() ) +
          ':' + this.pad( dt.getMinutes() ) +
          ':' + this.pad( dt.getSeconds() ) +
          '.' + (dt.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
          'Z';
    };
    toDate(obj){
        if(!obj){
            return null;
        }
        if(typeof obj === 'string'){
            if(obj.endsWith('Z')){
                return new Date(obj);
            }else{
                //return new Date(obj+'Z');
                return new Date(obj);
            }
        }else if(typeof obj.getMonth === 'function'){
            return obj;
        }else{
            return null;
        }
    }
    isMoreThanOneDay(start,end){
        if(!start){
            return false;
        }
        if(!end){
            return false;
        }
        start = this.toDate(start);
        end = this.toDate(end);
        const span = end.getTime() - start.getTime();
        const result = span >= 24*60*60*1000;
        return result;
    }
    //mm/dd/yy hh:mm
    toShortDateTime(dateStr) {
        if (!dateStr) {
            return '';
        }
        const date = this.toDate(dateStr);
        if(!date){
            return '';
        }
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + (date.getFullYear() - 2000)
            + '   ' + this.pad(date.getHours()) + ':' + this.pad(date.getMinutes());
    }
    toRoundDate(obj){
        if(!obj){
            return null;
        }
        const dt = this.toDate(obj);
        return new Date(dt.getFullYear(),dt.getMonth(),dt.getDate(),0,0);
    }
    roundDateForService(service) {
        if (!service) {
            return;
        }
        if (!service.start || !service.end) {
            return;
        }
        
        const dtStart = this.toDate(service.start);
        const dtEnd = this.toDate(service.end);

        if ((dtStart.getFullYear() === dtEnd.getFullYear()) &&
            (dtStart.getMonth() === dtEnd.getMonth()) &&
            (dtStart.getDate() === dtEnd.getDate())){
            service.start = new Date(dtStart.getFullYear(), dtStart.getMonth(), dtStart.getDate(), 0, 0);
            service.end = new Date(dtEnd.getFullYear(), dtEnd.getMonth(), dtEnd.getDate(), 0, 0);
        }
        else {
            service.start = new Date(dtStart.getFullYear(), dtStart.getMonth(), dtStart.getDate(), 0, 1);
            service.end = new Date(dtEnd.getFullYear(), dtEnd.getMonth(), dtEnd.getDate(), 0, 1);
        }
    }
    isWithinTwoWeeks(d) {
        if (!d) {
            return false;
        }
        d = this.toDate(d);
        let now = new Date();
        let span = d.getTime() - now.getTime();
        if (span < 14 * 24 * 60 * 60 * 1000 && span >= 0) {
            return true;
        }
        return false;
    }
    isWithinEightHours(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return false;
        }
        if (minutes < 8 * 60 && minutes >= 0) {
            return true;
        } else {
            return false;
        }
    }
    isWithinPastThreeDays(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return false;
        }
        if (minutes < 0 && minutes >= -3 * 24 * 60) {
            return true;
        } else {
            return false;
        }
    }
    howManyMinutesToNow(d) {
        if (!d) {
            return null;
        }
        d = this.toDate(d);
        let now = new Date();
        let span = d.getTime() - now.getTime();
        return span / (1000 * 60);
    }
    howLongToNow(d) {
        const minutes = this.howManyMinutesToNow(d);
        if (!minutes) {
            return null;
        }
        if (minutes < 60) {
            return Math.round(minutes) + ' Mins';
        } else if (minutes < 24 * 60) {
            return Math.round(minutes / 60) + ' Hours';
        } else {
            return Math.round(minutes / (24 * 60)) + ' Days';
        }
    }
    compare(obj1,obj2){
        if(!obj1){
            return 0;
        }
        if(!obj2){
            return 0;
        }
        const d1 = this.toDate(obj1);
        const d2 = this.toDate(obj2);
        if(d1 > d2){
            return 1;
        }else if(d1 < d2){
            return -1;
        }else{
            return 0;
        }
    }
    compare2(obj1,obj2){
        if(!obj1){
            return -1;
        }
        if(!obj2){
            return 1;
        }
        const d1 = this.toDate(obj1);
        const d2 = this.toDate(obj2);
        if(d1 > d2){
            return 1;
        }else if(d1 < d2){
            return -1;
        }else{
            return 0;
        }
    }
    isGreater(obj1,obj2){
        return this.compare(obj1,obj2) === 1;
    }
    isLess(obj1,obj2){
        return this.compare(obj1,obj2) === -1
    }
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    toVagueDate(dateStr) {
        if (!dateStr) {
            return '';
        }
        var date = this.toDate(dateStr);
        return this.months[date.getMonth()] + '-' + (date.getFullYear() - 2000);
    }
}

export default new DateHelper();